
/*----------------------
       SLIDER
---------------------- */
window.Slider = {
  init: function () {
    $(".swiper-sliderbig").each(function () {
      var sliderElement = this;
      if (sliderElement.swiper) return;

      var mobileViewport = window.matchMedia("(max-width: 640px)");
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var sliderInViewport = !("IntersectionObserver" in window);
      var hasMultipleSlides = $(sliderElement).find(".swiper-slide").length > 1;

      function constrainedPlayback() {
        return mobileViewport.matches || reducedMotion.matches || Boolean(connection && connection.saveData);
      }

      var automaticSlidesEnabled = hasMultipleSlides && !constrainedPlayback();

      function normalizeAndPauseVideos(swiper) {
        $(swiper.el).find("video").each(function () {
          this.autoplay = false;
          this.removeAttribute("autoplay");
          this.preload = "none";
          this.setAttribute("preload", "none");
          this.playsInline = true;
          this.setAttribute("playsinline", "");
          this.muted = true;
          this.pause();
          if (window.MarlotVideoPlaybackCoordinator) {
            window.MarlotVideoPlaybackCoordinator.register(this);
          }
        });
      }

      function syncActiveVideo(swiper) {
        normalizeAndPauseVideos(swiper);

        var canAnimate = sliderInViewport && !document.hidden && !constrainedPlayback();
        if (swiper.autoplay) {
          if (canAnimate && automaticSlidesEnabled) {
            swiper.autoplay.start();
          } else {
            swiper.autoplay.stop();
          }
        }
        if (!canAnimate) return;

        var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
        var activeVideo = activeSlide && activeSlide.querySelector("video");
        if (!activeVideo) return;
        if (window.MarlotVideoPlaybackCoordinator) {
          window.MarlotVideoPlaybackCoordinator.requestPlay(activeVideo);
        }
      }

      var swiper = new Swiper(sliderElement, {
        effect: "fade",
        loop: hasMultipleSlides,
        autoplay: automaticSlidesEnabled ? {
          delay: 5000,
          disableOnInteraction: false
        } : false,
        on: {
          init: function () {
            syncActiveVideo(this);
          },
          slideChangeTransitionStart: function () {
            syncActiveVideo(this);
          }
        },
      });

      if ("IntersectionObserver" in window) {
        var sliderObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          sliderInViewport = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
          syncActiveVideo(swiper);
        }, { threshold: [0, 0.01, 0.5] });
        sliderObserver.observe(sliderElement);
      }

      document.addEventListener("visibilitychange", function () {
        syncActiveVideo(swiper);
      });

      [mobileViewport, reducedMotion].forEach(function (mediaQuery) {
        if (typeof mediaQuery.addEventListener === "function") {
          mediaQuery.addEventListener("change", function () {
            syncActiveVideo(swiper);
          });
        } else if (typeof mediaQuery.addListener === "function") {
          mediaQuery.addListener(function () {
            syncActiveVideo(swiper);
          });
        }
      });

      if (connection && typeof connection.addEventListener === "function") {
        connection.addEventListener("change", function () {
          syncActiveVideo(swiper);
        });
      }
    });
  }
};

$(document).ready(function () {
  window.Slider.init();
});
$(document).on('shopify:section:load', function (event) {
  window.Slider.init();
});
